export const MIN_MAX_CONNECTIONS = {
  min: 1,
  max: 99,
};

export function getValidatedConnectionsValue(value: string): {
  currentValue: string;
  prevValue: string;
  nextValue: string;
} {
  const { min, max } = MIN_MAX_CONNECTIONS;

  const num = parseInt(value, 10);
  if (Number.isNaN(num)) {
    return { currentValue: '', prevValue: '', nextValue: `${min}` };
  }

  const potentialResult = {
    currentValue: num,
    prevValue: num - 1,
    nextValue: num + 1,
  };

  const result = {
    currentValue: String(potentialResult.currentValue),
    prevValue: String(potentialResult.prevValue),
    nextValue: String(potentialResult.nextValue),
  };

  if (potentialResult.currentValue === min) {
    result.prevValue = '';
  }

  if (potentialResult.currentValue === max) {
    result.nextValue = `${max}`;
  }

  if (potentialResult.currentValue < min) {
    result.currentValue = '';
    result.prevValue = '';
    result.nextValue = '1';
  }

  if (potentialResult.currentValue > max) {
    result.currentValue = `${max}`;
    result.prevValue = `${max - 1}`;
    result.nextValue = `${max}`;
  }

  return result;
}
